'use client'

import { Stars } from '@/core/ui/atoms/stars'
import { ArrowLeft, ArrowRight } from 'lucide-react'
import { useTranslations } from 'next-intl'
import { useState } from 'react'
type TestimonialItem = {
  name: string
  rate: number
  review: string
  date: string
}

export const TestimonialCard: React.FC<TestimonialItem> = ({
  name,
  rate,
  review,
  date,
}) => {
  const [isExpanded, setIsExpanded] = useState(false)
  const t = useTranslations()

  const MAX_REVIEW_LENGTH = 150
  const shouldTruncate = review.length > MAX_REVIEW_LENGTH

  const truncatedReview = shouldTruncate
    ? `${review.slice(0, MAX_REVIEW_LENGTH)}...`
    : review

  const toggleReview = () => {
    setIsExpanded(!isExpanded)
  }

  return (
    <div
      className={`bg-grey-2 me-8 mb-4 flex flex-col justify-start rounded-md p-6 shadow-[-6px_8px_2px_#DEF4FA] transition-all hover:shadow-[-8px_10px_4px_#DEF4FA] ${isExpanded ? 'h-auto' : 'h-96 sm:h-72 lg:h-96 xl:h-72'}`}
    >
      <div>
        <h6 className='text-darkBlue mb-1 text-lg font-medium'>{name}</h6>
        <Stars rating={rate} />
      </div>

      <p className='text-navy mt-4'>{isExpanded ? review : truncatedReview}</p>

      {shouldTruncate ? (
        <button
          className='text-red mt-2 flex w-fit items-center gap-1 font-medium hover:underline'
          onClick={toggleReview}
          aria-label={
            isExpanded ? t('actions.readLess') : t('actions.readMore')
          }
        >
          {isExpanded ? (
            <>
              {t('actions.readLess')}
              <ArrowLeft className='ml-1' />
            </>
          ) : (
            <>
              {t('actions.readMore')}
              <ArrowRight className='ml-1' />
            </>
          )}
        </button>
      ) : null}

      <p className='text-sky-blue mt-auto pt-2 font-medium'>{date}</p>
    </div>
  )
}
